import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ALL_USERS } from './constants';
import {
  AllUsersSuccess,
  AllUsersError,
  AllUsersDataActionTypes,
  AllUsersState,
} from './types';

const initialState: AllUsersState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: AllUsersDataActionTypes): AllUsersState => {
    switch (action.type) {
      case ALL_USERS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_USERS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllUsersSuccess).payload.items;
        break;
      }
      case ALL_USERS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllUsersError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
